import { render, staticRenderFns } from "./ResultOverview.vue?vue&type=template&id=25198361&"
import script from "./ResultOverview.vue?vue&type=script&lang=js&"
export * from "./ResultOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports